<template>
  <div class=" pdl-16 mgt-8" v-if="imageArray.images && imageArray.images.length">
    <swiper
      :options="swiperOption"
      class=" brand-slider pdx-4"
      :class="fileData ? 'reply-attach-swiper' : 'attach-swiper'"
      ref="mySwiper"
    >
      <swiper-slide
        class="position-relative"
        v-for="(img, i) in imageArray.images"
        :key="i"
      >
        <img
          v-if="getType(img.contentType) === 'image'"
          class="cursor-pointer b-radius4"
          :src="img.resourceUri"
          :alt="img.originalName"
          @click="displayFileData(img)"
          @keypress="displayFileData(img)"
          tabindex="0"
        />
        <VideoComponent
            v-else
            :record="img"
            :videoSize="'medium'"
            :fullSizeVideo="false"
            @click="displayFileData(img)"
            @keypress="displayFileData(img)"
            tabindex="0"
        >
        </VideoComponent>
        <div
          style="position:absolute; background-color:transparent; width:100%;height:100%; z-index:999; top:0; cursor:pointer"
          @click="displayFileData(img)"
          @keypress="displayFileData(img)"
          tabindex="0"
        ></div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import VideoComponent from "@/components/common/VideoComponent.vue";
export default {
  props: ["imageArray", "fileData"],

  components: {
    swiper,
    swiperSlide,
    VideoComponent
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 8,
        //	centeredSlides: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
        },
      },
    };
  },

  computed: {
    // swiper define
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  methods: {
    getType(contentType) {
      return contentType.split("/")[0];
    },

    displayFileData(img) {
      this.$emit("fileDisplay", img);
    },
  },
};
</script>
<style scoped>
/* .attach-swiper .swiper-slide{
	width:126px!important;

} */
.swiper-container.attach-swiper {
  max-width: 698px !important;
  margin-left: 0;
  /* margin-right:-40px; */
}
html[dir="rtl"] .swiper-container.attach-swiper {
  margin-right: 0;
}
.swiper-container.reply-attach-swiper {
  max-width: 640px !important;
  margin-left: 0;
}
html[dir="rtl"] .swiper-container.reply-attach-swiper {
  margin-right: 0;
}
.attach-swiper .swiper-slide,
.reply-attach-swiper .swiper-slide {
  width: 126px !important;
  height: 126px !important;
}
.attach-swiper .swiper-slide img,
.reply-attach-swiper .swiper-slide img {
  width: 126px !important;
  height: 126px !important;
  object-fit: cover;
}
.attach-swiper .swiper-slide .video-player-box .video-js,
.reply-attach-swiper .swiper-slide .video-player-box .video-js {
  width: 126px !important;
  height: 126px !important;
}
</style>
